import { useState, useEffect } from "react";
import CreateNewPlanForm from "../plans-management-components/CreateNewPlanForm";
import { Content } from "../../utils/Content";
import {
  Typography,
  Grid,
  Box,
  StepLabel,
  Button,
  Step,
  Stepper,
  Snackbar,
  Alert,
  Dialog,
  Slide,
  DialogTitle,
  Stack,
  DialogActions,
} from "@mui/material";
import { useMenu } from "../../context/MenuOpenContext";
import { useTranslation } from "react-i18next";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link } from "react-router-dom";
import { useLocation, useParams } from "react-router-dom";
import ImageUploadModal from "../plans-management-components/ImageUploadModal";
import { useNavigate } from "react-router-dom";
import { usePlan } from "../../context/PlanContext";
import { forwardRef } from "react";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function CreateNewPlanLayout() {
  const [activeStep, setActiveStep] = useState(0);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const navigate = useNavigate();

  const [planIdFromResponse, setPlanIdFromResponse] = useState("");
  const [mode, setMode] = useState("");
  const {
    isPlanCreated,
    handleIsPlanCreated,
    resetPlanStates,
    handleIsPlanUpdate,
  } = usePlan();
  const { isOpen } = useMenu();
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { state } = useLocation();
  const { planId } = useParams();

  const [showImageUploadModal, setShowImageUploadModal] = useState(false);
  const steps = [t("plan.createNew.name"), t("plan.createNew.imageUpload")];

  useEffect(() => {
    pathname.includes("editPlan") ? setMode("edit") : setMode("new");
  }, [pathname]);

  useEffect(() => {
    console.log(planIdFromResponse);
  }, [planIdFromResponse]);

  const handlePlanCreated = (idPlan) => {
    setPlanIdFromResponse(idPlan);
  };

  const finalizeCreatePlan = () => {
    resetPlanStates();
    navigate(`/plansManagement?tab=0`);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    handleIsPlanCreated();
  };

  return (
    <Content open={isOpen}>
      <Snackbar
        open={isPlanCreated}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity="success">{t("createEditPlan.success.message")}</Alert>
      </Snackbar>

      <Grid container spacing={1} ml={{ xs: 0, sm: 2 }} mb={2}>
        <Link
          to={"/plansManagement?tab=0"}
          className="nav-link_back"
          underline="none"
        >
          <ArrowBackIcon sx={{ marginRight: "5px" }} />
          {t("back.button")}
        </Link>
      </Grid>
      <Grid container>
        <Grid item xs={12} sm={6}>
          <Box paddingX={"20px"}>
            <Typography
              variant="h4"
              color={"primary"}
              textAlign={"flex-start"}
              sx={{ textTransform: "uppercase" }}
              fontWeight={800}
            >
              {mode === "edit"
                ? t("editPlan.title")
                : t("plan.createNew.title")}
            </Typography>
          </Box>
          <Box my={2} paddingX={"20px"}>
            <Typography variant="body1" textAlign={"flex-start"}>
              {mode === "edit"
                ? t("editPlan.description")
                : t("plan.createNew.subtitle")}
            </Typography>
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        ></Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <Box
            paddingX={{ xs: "0", sm: "20px" }}
            mt={"1rem"}
            sx={{
              width: "100%",
            }}
          >
            {mode === "new" && (
              <Stepper
                sx={{ mb: "2rem", width: "80%", ml: "10%" }}
                activeStep={activeStep}
                orientation="horizontal"
              >
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            )}
            <Box>
              {activeStep === steps.length ? (
                finalizeCreatePlan()
              ) : (
                <div>
                  {activeStep === 0 ? (
                    <CreateNewPlanForm
                      mode={mode}
                      planId={planId}
                      handleNext={handleNext}
                      handlePlanCreated={handlePlanCreated}
                    />
                  ) : (
                    <Box>
                      {mode === "new" && (
                        <Dialog
                          disableEscapeKeyDown
                          open={isOpen}
                          TransitionComponent={Transition}
                        >
                          <DialogTitle sx={{ p: "1rem" }}>
                            <Stack
                              alignItems={"center"}
                              justifyContent="center"
                            >
                              <Typography variant="h6">
                                ¿Deseas subir una imagen para este plan?
                              </Typography>
                            </Stack>
                          </DialogTitle>
                          <DialogActions sx={{ p: "1.5rem", gap: "0.5rem" }}>
                            <Button
                              color="secondary"
                              variant="contained"
                              onClick={() => setShowImageUploadModal(true)}
                            >
                              Sí
                            </Button>
                            <Button
                              color="secondary"
                              variant="contained"
                              onClick={() => finalizeCreatePlan()}
                            >
                              No
                            </Button>
                          </DialogActions>

                          {showImageUploadModal && (
                            <ImageUploadModal
                              planId={
                                mode === "edit" ? planId : planIdFromResponse
                              }
                            />
                          )}
                        </Dialog>
                      )}
                    </Box>
                  )}
                </div>
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Content>
  );
}
